/**
 * ConfirmPasswordForm.jsx
 * Created by michaelbray on 2/13/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import PasswordStrengthIndicator from '../../../../components/sharedComponents/PasswordStrengthIndicator';
import * as Icons from '../../../sharedComponents/icons/Icons';

const propTypes = {
    label: PropTypes.string,
    errorText: PropTypes.string,
    confirmPasswords: PropTypes.func
};

export default class ConfirmPasswordForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            password1: '',
            password2: ''
        };

        this.password1TextChange = this.password1TextChange.bind(this);
        this.password2TextChange = this.password2TextChange.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    componentDidMount() {
        this.password1.focus();
    }

    password1TextChange(e) {
        this.setState({
            password1: e.target.value
        });
    }

    password2TextChange(e) {
        this.setState({
            password2: e.target.value
        });
    }

    submitForm(e) {
        e.preventDefault();

        this.props.confirmPasswords({
            password1: this.state.password1,
            password2: this.state.password2
        });
    }

    render() {
        let error = null;

        if (this.props.errorText) {
            error = (
                <div className="rec-notification-error">
                    <span className="rec-notification-icon">
                        <Icons.IconWarning />
                    </span>
                    <div className="rec-notification-body">
                        <p>{this.props.errorText}</p>
                    </div>
                </div>
            );
        }
        
        return (
            <div>
                <div className="rec-modal-title">{this.props.label}</div>
                {error}
                <form onSubmit={this.submitForm}>
                    <div className="form-item-wrap">
                        <label
                            htmlFor="rec-acct-password"
                            className="rec-sr-only">
                            Password
                        </label>
                        <input
                            type="password"
                            ref={(password1) => this.password1 = password1}
                            onChange={(event) => this.password1TextChange(event)}
                            placeholder="Password"
                            className="rec-acct-password"
                            id="rec-acct-password"
                            autoComplete="off" />
                        <div className="form-item-icon-holder">
                            <Icons.IconLock className="rec-icon-lock" />
                        </div>
                    </div>
                    <div className="form-item-wrap">
                        <label
                            htmlFor="rec-acct-password-confirm"
                            className="rec-sr-only">
                            Confirm Password
                        </label>
                        <input
                            type="password"
                            ref={(password2) => this.password2 = password2}
                            onChange={(event) => this.password2TextChange(event)}
                            placeholder="Re-enter Password"
                            className="rec-acct-password"
                            id="rec-acct-password-confirm"
                            autoComplete="off" />
                        <div className="form-item-icon-holder">
                            <Icons.IconLock className="rec-icon-lock" />
                        </div>
                        <PasswordStrengthIndicator password={this.state.password1} />
                    </div>
                    <button
                        className="rec-button-primary"
                        title={this.props.label}
                        aria-label={this.props.label}>
                        {this.props.label}
                    </button>
                </form>
            </div>
        );
    }
}

ConfirmPasswordForm.propTypes = propTypes;
